import React from "react";
import Box from "@mui/material/Box";
import { makeStyles } from "tss-react/mui";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";

const useStyles = makeStyles()({
  formContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: "0px 15px",
    textAlign: "left",
    minHeight: "250px",
  },
});

export default function DownloadMetadata({ enable, setEnable, downloadXML }) {
  const { classes } = useStyles();

  return (
    <Box sx={{ width: "100%" }} component="form" className={classes.formContainer}>
      <Grid container spacing={2}>
        <Grid sx={{ width: "100px !important" }} size={12}>
          <Alert severity="info">
            Here is the information you need to complete the Configuration on your Identity Provider side:
          </Alert>
        </Grid>
        <Grid size={12}>
          <span>Download SP Metadata document:</span>
          <Button style={{ color: "#1976d2" }} variant="text" onClick={downloadXML}>
            Download
          </Button>
        </Grid>

        <Grid size={12}>
          <FormControlLabel
            control={
              <Checkbox
                value={+enable}
                checked={enable !== undefined && enable ? true : false}
                onChange={(e) => setEnable(e.target.checked)}
              />
            }
            label="Everything is ready, enable this connection!"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
